import PropTypes from "prop-types";
import React, { Component } from "react";
import moment from "moment";
import { Card, Icon, Grid, Loader } from "semantic-ui-react";

import "./attachmentCard.scss";

class AttachmentCard extends Component {
  static propTypes = {
    attachment: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  render() {
    const { attachment } = this.props;
    const { loading } = this.state;
    return (
      attachment &&
      attachment.id && (
        <Card
          key={`attachment-${attachment.id}`}
          data-component="attachmentCard"
        >
          <Card.Content>
            <a
              target={`attachment-${attachment.id}`}
              href={attachment.attachment_url}
              data-tooltip={attachment.file_name}
            >
              <Icon
                name="file outline"
                size="huge"
                color="grey"
                style={loading ? { visibility: "hidden" } : null}
              />
              {loading && <Loader size="huge" active />}
            </a>
          </Card.Content>
          <Card.Content extra>
            <Grid className="attachmentDetails">
              <Grid.Column width="16" textAlign="center">
                <div className="truncate">{attachment.display_name}</div>
              </Grid.Column>
              <Grid.Column width="16" textAlign="center">
                <small>
                  <time className="date">
                    {moment(attachment.updated_at).format("DD.MM.YYYY")}
                  </time>
                </small>
              </Grid.Column>
            </Grid>
          </Card.Content>
        </Card>
      )
    );
  }
}

export default AttachmentCard;
